import React, { useMemo, useRef } from 'react';
import { makeStyles } from '@material-ui/core';
import AddCircleIcon from '@material-ui/icons/AddCircle';
import CancelIcon from '@material-ui/icons/Cancel';
import useModal from 'src/hooks/useModal';
import AttributeDetailsPopover from 'src/components/EntityInspector/EntityInspectorDialog/EntityCard/AttributeDetailsPopover';
import { isNil } from 'ramda';
import { EntityDataTypes } from 'src/interfaces/modular/entityInfoTypes';
// eslint-disable-next-line import/no-cycle
import EntityCollection from 'src/components/EntityInspector/EntityInspectorDialog/EntityCollection';
// eslint-disable-next-line import/no-cycle
import EntityInstance from 'src/components/EntityInspector/EntityInspectorDialog/EntityInstance';
const useStyles = makeStyles((theme) => ({
    value: {
        wordWrap: 'break-word',
        wordBreak: 'break-all'
    },
    nameCell: {
        paddingLeft: theme.spacing(2),
        paddingRight: theme.spacing(2),
        verticalAlign: 'top',
        width: 0
    },
    valueCell: {
        display: 'flex',
        alignItems: 'center',
        gap: theme.spacing(1),
        paddingRight: theme.spacing(2),
        width: '100%',
        minWidth: 200
    },
    icon: {
        cursor: 'pointer',
        fontSize: 18,
        color: theme.palette.primary.main,
        transition: 'opacity 0.2s',
        '&:hover': {
            opacity: 1
        }
    }
}));
function EntityAttribute({ attr, primaryKeyValue }) {
    const classes = useStyles();
    const valueNodeRef = useRef(null);
    const { isOpen: infoOpen, closeModal: closeInfo, openModal: openInfo } = useModal();
    const { isOpen: expanded, closeModal: closeExpansion, openModal: openExpansion } = useModal();
    const isExpandable = attr.Type === EntityDataTypes.Collection
        || (!isNil(attr.RefEntity) && !isNil(attr.Value)); // is instance
    const renderExpansionButton = () => {
        const Icon = expanded ? CancelIcon : AddCircleIcon;
        return (React.createElement(Icon, { className: classes.icon, onClick: expanded ? closeExpansion : openExpansion, opacity: expanded ? 1 : 0.6 }));
    };
    const expansion = useMemo(() => {
        if (attr.Type === EntityDataTypes.Collection) {
            const entryPointData = {
                name: attr.RefEntity,
                propertyValue: primaryKeyValue,
                property: attr.RefProperty
            };
            return React.createElement(EntityCollection, { entity: entryPointData });
        }
        else {
            const entryPointData = { name: attr.RefEntity, id: attr.Value };
            return React.createElement(EntityInstance, { entity: entryPointData });
        }
    }, [attr, primaryKeyValue]);
    const getValue = (value) => {
        const candidate = String(value);
        return candidate.trim() === ''
            ? React.createElement("i", null, "<empty string>")
            : React.createElement("code", { className: classes.value }, candidate);
    };
    return (React.createElement(React.Fragment, null,
        React.createElement("tr", null,
            React.createElement("td", { className: classes.nameCell }, attr.Name),
            React.createElement("td", { className: classes.valueCell },
                React.createElement("span", { ref: valueNodeRef, onMouseEnter: openInfo, onMouseLeave: closeInfo }, getValue(attr.Value)),
                React.createElement(AttributeDetailsPopover, { open: infoOpen, anchorEl: valueNodeRef.current, attr: attr, onClose: closeInfo }),
                isExpandable && (renderExpansionButton()))),
        expanded && (React.createElement("tr", null,
            React.createElement("td", null),
            React.createElement("td", null, expansion)))));
}
export default EntityAttribute;
